import React from 'react';
import { useLocation, Route, Switch, Redirect, useHistory } from 'react-router-dom';
import routes from 'routes.js';
import Logo from '../assets/img/brand/veriscan-white.png';
import '../assets/css/auth.css';

const Auth = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const history = useHistory();
  const token = localStorage.getItem('token');

  React.useEffect(() => {
    document.body.classList.add('bg-default');
    return () => {
      document.body.classList.remove('bg-default');
    };
  }, []);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
      }
      return null;
    });
  };

  if (token) {
    history.push('/admin/index');
  }

  return (
    <div className="auth-page" ref={mainContent}>
      <nav className="auth-navbar">
        <a href="https://getveriscan.com" className="auth-navbar__logo">
          <img src={Logo} alt="VeriScan" />
        </a>
        <a
          href="https://getveriscan.com/request-a-demo/"
          target="_blank"
          rel="noopener noreferrer"
          className="auth-navbar__link"
        >
          <i className="ni ni-badge" />
          <span>No Account? Start Here</span>
        </a>
      </nav>

      <div className="auth-content">
        <Switch>
          {getRoutes(routes)}
          <Redirect from="*" to="/auth/login" />
        </Switch>
      </div>
    </div>
  );
};

export default Auth;
